<template>
  <div>
    <label> {{label}}</label>
    <span class="red" v-if="required">*</span>
    <input 
      :id="inputId"
      type="text"
      :class="`${isValid ? 'is-invalid' : ''} form-control`"
      :value="value"
      :disabled="disabled"
      :readonly="readonly"
      @keypress.enter.prevent
      @focusout="validateEntry(this)" />

    <div class="invalid-feedback" v-if="message.length > 0">
      {{message}}
    </div>
  </div>
</template>

<script>

    export default {
        props: [
          'inputId', 
          'name',
          'className',
          'value',
          'rules',
          'label',
          'disabled',
          'readonly', 
          'required'
        ],
        data() {
        return {
            message: '',
            isValid: false
          }
        },
        methods: {
          // Use if there is custom validation

          validateEntry() {
            event.preventDefault();
            
          }
        }
    }
</script>

<!-- <text-input
inputId="name_en"
name="name_en"
required="true"
:label="$t('name_en.label')"
v-model.number="examType.name.en" 
className="form-control"
/>   -->
